module.exports = __webpack_public_path__ + "static/media/damacai_logo.e907d834.svg";